<template>
    <div ref="drawer" class="modal-card drawer_opener"
        :data-theme="theme || null"
        :style="{ width: width + ' !important' }">
        <header class="modal-card-head">
            <!-- v-on="$listeners" reenvía cualquier listener registrado por el
                caller (via $buefy.modal.open events:) al header dinámico. El
                @close-modal explícito sigue manejando la animación local.
                `payload` (no `data`) — evita la colisión semántica con el
                `data()` reactive state de cada componente hijo.
                Forward-compat Vue 3: $listeners se fusiona con $attrs y este
                v-on hay que reemplazarlo por `v-bind="$attrs"`. Funciona en
                Vue 2.7 tal cual; el codemod del migration build lo cambia. -->
            <component :is="headerComp" :payload="headerProps"
                v-on="$listeners"
                @close-modal="closeModal"></component>
        </header>
        <section class="modal_back_caa">
            <component :is="bodyComp" :payload="bodyProps"></component>
        </section>
    </div>
</template>


<script>

const CLOSE_ANIMATION_MS = 150;

export default {
    name: "ModalFullHeightRight",
    props: {
        headerComp: { type: Object, required: true },
        bodyComp: { type: Object, required: true },
        headerProps: { type: Object, default: null },
        bodyProps: { type: Object, default: null },
        // El modal se monta vía $buefy.modal.open, fuera del subárbol
        // data-theme del tab. Aceptamos el theme explícito para que los tokens
        // --report-* del tab activo apliquen dentro del drawer (ver
        // _report_themes.scss: cada [data-theme="X"] reescribe los tokens).
        theme: { type: String, default: null },
        // Ancho del drawer como CSS width. Override el default 85% cuando se
        // stackean varios drawers: pasar un ancho menor al child para que
        // visualmente se note que está "encima" del padre y deje ver una
        // franja del modal anterior.
        width: { type: String, default: "85%" },
    },
    data() {
        return {
            closeTimeoutId: null,
        };
    },
    mounted() {
        this.openModalAnimation();
    },
    beforeDestroy() {
        if (this.closeTimeoutId !== null) {
            clearTimeout(this.closeTimeoutId);
            this.closeTimeoutId = null;
        }
        this.$emit('closed');
    },
    methods: {
        closeModal() {
            const drawer = this.$refs.drawer;
            if (!drawer) {
                this.$emit('close');
                return;
            }
            drawer.classList.remove('drawer_animation');
            this.closeTimeoutId = setTimeout(() => {
                this.closeTimeoutId = null;
                this.$emit('close');
            }, CLOSE_ANIMATION_MS);
        },
        openModalAnimation() {
            this.$nextTick(() => {
                const drawer = this.$refs.drawer;
                if (drawer) {
                    drawer.classList.add('drawer_animation');
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.modal_back_caa {
    background-color: var(--report-surface);
    padding: 32px;
    // El drawer es flex-column (bulma .modal-card). flex:1 + min-height:0 deja
    // que esta section ocupe el espacio restante debajo del head y propaguen
    // los hijos. `overflow: auto` (no `hidden`) preserva el contrato de los
    // otros callers (Header.vue, MainLayout.vue, DashboardClassificator.vue):
    // si su body desborda, scrollea acá. El body de Ventas se autoclampa con
    // sus propios flex/overflow internos así que `auto` nunca engancha.
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.drawer_opener {
    position: absolute !important;
    top: 0 !important;
    height: 100% !important;
    max-height: 100% !important;
    background: var(--report-bg);
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    transition: right 0.35s ease-in-out;
    z-index: 1050;
    // width viene de la prop (default 85%) y se pinta inline en el root;
    // dejamos el fallback acá por si algún caller histórico monta el
    // componente sin definir la prop por reflexión rara.
    width: 85%;
}

.drawer_animation {
    right: 0px !important;
}
</style>
